import { ModalSection } from '@/shared/components/SDComponents/SDModal/styled-components'
import SDCheckbox from '@/shared/components/SDComponentsNewDesign/SDCheckbox/SDCheckbox'
import { LABEL_PLACEMENT } from 'baseui/checkbox'
import { CheckboxGroup } from '@/containers/SubscriptionFormPageNew/Components/ModalSaveAndSend/styled-components'
import useContact from '@/containers/SubscriptionFormPageNew/Components/Contact/useContact'
import { updateClientData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { useDispatch } from 'react-redux'
import useSaveButtons from '@/containers/SubscriptionFormPageNew/Components/SaveButtons/useSaveButtons'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'

const ModalEkomiEmail = ({ hidden }) => {
  const dispatch = useDispatch()
  const { t, isEditable } = useSaveButtons({ setIsOpen: null })

  const { isEkomiRegistered, createEkomiInteraction } = useContact()

  if (hidden) return null

  const checked = isEkomiRegistered || !!createEkomiInteraction

  const handleChange = value => {
    dispatch(
      updateClientData({
        name: 'preferences',
        data: { createEkomiInteraction: value ? true : null },
      }),
    )
  }

  return (
    <ModalSection>
      <CheckboxGroup>
        <SDCheckbox
          disabled={isEkomiRegistered || !isEditable}
          checked={checked}
          onChange={handleChange}
          labelPlacement={LABEL_PLACEMENT.right}
          label={t('subscriptionForm:header.modal_save_send.ekomi_mail_text')}
        />
        <SDNotification
          type='info'
          hidden={!isEkomiRegistered}
          primaryText={t('subscriptionForm:header.modal_save_send.ekomi_already_registered')}
        />
      </CheckboxGroup>
    </ModalSection>
  )
}

export default ModalEkomiEmail
